export const errorMessageId: Record<string, string> = {
  mobileNumber: 'errors.validation.mobileNumber',
  url: 'errors.validation.url',
  socialMedia: 'errors.validation.url',
  dob: 'errors.validation.dob',
}
